import React from 'react';
import { CardActionArea, CardMedia, Stack, Typography, useTheme } from '@mui/material';

import { FavUnfavIcon } from '../FavUnfavIcon';
import { TruncatedTypography } from '../typography';
import { SvgColor } from '../svg-color';

interface Props {
  image: string;
  dishName: string;
  cookingTime: string;
  ratings: string;
  description: string;
  id: string;
  onClick?: VoidFunction;
}

const CARD_DIMENSIONS = {
  width: '100%',
  height: 150,
};

const styles = {
  cardContainer: {
    ...CARD_DIMENSIONS,
    bgcolor: 'white',
    minWidth: '320px',
    borderRadius: '10px',
    boxShadow: '0px 2px 5px rgba(73, 67, 67, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'row',
    p: 1,
  },
  favIcon: {
    position: 'absolute' as const,
    top: '15px',
    left: '33%',
    color: 'red',
    backgroundColor: 'white',
    height: '25px',
    width: '25px',
  },
  cardMedia: {
    width: '40%',
    height: '100%',
    objectFit: 'cover' as const,
    borderRadius: '10px',
  },
  icons: {
    fontSize: 10,
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
};

const RecipeCard: React.FC<Props> = ({
  image,
  id,
  dishName,
  cookingTime,
  ratings,
  description,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <CardActionArea onClick={onClick}>
      <Stack sx={styles.cardContainer}>
        <FavUnfavIcon id={id} style={styles.favIcon} />
        <CardMedia component="img" image={image} sx={styles.cardMedia} />
        <Stack sx={{ p: 1, width: '60%' }}>
          <Stack>
            <TruncatedTypography fontSize={14} fontWeight={'bold'} text={dishName} />
            <Typography
              fontSize={12}
              color={theme.palette.tertiary.shadyText}
              sx={{
                overflow: 'hidden',
                height: 80,
              }}
            >
              {description}
            </Typography>
          </Stack>

          <Stack sx={{ flexDirection: 'row', mb: 10 }}>
            {/* ------ */}
            <SvgColor
              src={`/assets/icons/ic_time.svg`}
              color={theme.palette.tertiary.shadyText}
              fontWeight={'bold'}
              sx={{ height: 14 }}
            />
            <Typography sx={styles.icons} color={theme.palette.tertiary.shadyText}>
              {cookingTime}
            </Typography>
            {/* ------- */}
            <SvgColor
              src={`/assets/icons/ic_star.svg`}
              color={theme.palette.tertiary.shadyText}
              fontWeight={'bold'}
              sx={{ height: 14 }}
            />
            <Typography sx={styles.icons} color={theme.palette.tertiary.shadyText}>
              {ratings}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </CardActionArea>
  );
};

export { RecipeCard };
